import type { CelebrationSpec, CelebrationVariant } from '../../../themes/types';
import { useVariantKeys } from './useVariantKeys';

interface CelebrationSectionProps {
  readonly value: CelebrationSpec;
  readonly onChange: (value: CelebrationSpec) => void;
}

const KINDS: CelebrationVariant['kind'][] = ['confetti', 'fireworks', 'balloons'];
const KIND_LABEL: Record<CelebrationVariant['kind'], string> = {
  confetti: 'Konfetti',
  fireworks: 'Ilotulitus',
  balloons: 'Ilmapallot',
};

export function CelebrationSection({ value, onChange }: CelebrationSectionProps) {
  const keyFor = useVariantKeys<CelebrationVariant>();
  const setVariant = (idx: number, kind: CelebrationVariant['kind']) => {
    const next = value.variants.slice();
    next[idx] = { kind } as CelebrationVariant;
    onChange({ ...value, variants: next });
  };
  const add = () => onChange({ ...value, variants: [...value.variants, { kind: 'confetti' }] });
  const remove = (idx: number) =>
    onChange({ ...value, variants: value.variants.filter((_, i) => i !== idx) });

  return (
    <fieldset className="theme-editor__section">
      <legend>Juhlaruutu</legend>
      {value.variants.map((v, i) => (
        <div key={keyFor(v)} className="theme-editor__variant-row">
          <select
            value={v.kind}
            onChange={(e) => setVariant(i, e.target.value as CelebrationVariant['kind'])}
          >
            {KINDS.map((k) => (
              <option key={k} value={k}>
                {KIND_LABEL[k]}
              </option>
            ))}
          </select>
          {value.variants.length > 1 ? (
            <button type="button" onClick={() => remove(i)} aria-label="Poista">
              ✕
            </button>
          ) : null}
        </div>
      ))}
      <button type="button" onClick={add}>
        Lisää variantti
      </button>
      {value.variants.length > 1 ? (
        <label>
          <span>Valintatapa</span>
          <select
            value={value.pickMode}
            onChange={(e) =>
              onChange({ ...value, pickMode: e.target.value as 'sequential' | 'random' })
            }
          >
            <option value="sequential">Vuoro</option>
            <option value="random">Arpa</option>
          </select>
        </label>
      ) : null}
    </fieldset>
  );
}
